import { Card } from '@/components/ui/card'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import {
  createBookingNew,
  searchAvailabilityListNew,
  searchAvailabilityNew,
} from '@/config/images'

export const TourModalCarousel: React.FC = () => {
  const images = [
    searchAvailabilityNew,
    searchAvailabilityListNew,
    createBookingNew,
  ]
  return (
    <Carousel className="w-full">
      <CarouselContent>
        {images.map((image, index) => (
          <CarouselItem key={index}>
            <Card className="relative overflow-hidden">
              <img
                src={image}
                alt={`Interface screenshot ${index}`}
                className="w-full h-full object-cover"
              />
            </Card>
          </CarouselItem>
        ))}
      </CarouselContent>
      <div className="absolute inset-y-0 left-8 right-8 flex items-center justify-between pointer-events-none">
        <CarouselPrevious
          className="pointer-events-auto"
          aria-label="Previous slide"
        />
        <CarouselNext className="pointer-events-auto" aria-label="Next slide" />
      </div>
    </Carousel>
  )
}
